const areas = [
  { name: "Box Elder", desc: "Home of Ellsworth AFB, western Pennington County" },
  { name: "Summerset", desc: "Bedroom community north of Rapid City on US-16" },
  { name: "Piedmont", desc: "Western Black Hills community along I-90" },
  { name: "Sturgis", desc: "Meade County city 30 miles northeast of Rapid City" },
  { name: "Spearfish", desc: "Northern Hills community 45 miles north of Rapid City" },
  { name: "Lead", desc: "Historic gold-mining town in Lawrence County" },
  { name: "Deadwood", desc: "Historic gaming and tourism city in the Northern Hills" },
  { name: "Hot Springs", desc: "Fall River County city 50 miles south of Rapid City" },
];

export default function LocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-5">
              Serving Rapid City and All of the Black Hills Region
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              The nearest passport agency to Rapid City is in Denver, over 360 miles away via I-90 and I-25. Fast Passport Center eliminates that drive entirely — serving Pennington County, all Black Hills communities, and Ellsworth AFB.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              Whether you are in downtown Rapid City, the west side near Mount Rushmore access roads, or a surrounding Black Hills community, we handle your passport from door to door.
            </p>
            <div className="grid grid-cols-2 gap-3">
              {areas.map((area, i) => (
                <div key={i} className="flex items-start gap-2.5 bg-[#F7F8FA] rounded-lg p-3">
                  <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-[#F6C344] text-base"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-[#1A365D] text-sm">{area.name}</p>
                    <p className="text-gray-400 text-xs leading-snug">{area.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="rounded-lg overflow-hidden border border-gray-200 h-[420px]">
            <iframe
              title="Rapid City South Dakota Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d91530.7!2d-103.22005!3d44.08054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x877f7310b2bca6c5%3A0x5e2a5e3e9b8d1f1!2sRapid+City%2C+SD!5e0!3m2!1sen!2sus!4v1700000000000"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}